<template>
  <el-dialog
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :destroy-on-close="true"
    :before-close="cancel"
    width="20%"
    :title="$t('langcfg.txtRgpSettings')"
    id="colorbar"
  >
    <el-input
      v-for="(val, key) in rgpPosSettings"
      :key="key"
      v-model="rgpPosSettings[key]"
      @click.native.stop.prevent="handleClick(key)"
      @touchend.native.stop.prevent="handleClick(key)"
      style="font-size: 20px"
    >
      <template slot="prepend"
        ><p>{{ key }}:</p>
      </template>
    </el-input>
    <el-row slot="footer" class="dialog-footer">
      <el-button type="info" @click="save">
        {{ $t("langcfg.txtSave") }}
      </el-button>
      <el-button type="info" @click="cancel">
        {{ $t("langcfg.txtCancel") }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import EVENTS from "../../../bus";
import { objectCopy } from "../../../shared/utils";
export default {
  name: "RgpPos",
  components: {},
  data: function () {
    return {
      rgpPosSettings: window.rgpPosSettings
    };
  },
  created() {},
  props: {
    show: Boolean,
    rgpPos: {
      type: Object,
      default: () => {
        return {
          offsetX: 0,
          offsetY: 0,
          offsetZ: 5
        };
      }
    }
  },
  watch: {
    rgpPos: {
      handler: function (val) {
        this.rgpPosSettings = objectCopy(val);
      },
      deep: true
    }
  },
  methods: {
    handleClick(key) {
      let _self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, _self.rgpPosSettings[key], (value) => {
        _self.rgpPosSettings[key] = value;
      });
    },
    save: function () {
      for (let id in this.rgpPosSettings) {
        if (Number.isNaN(parseFloat(this.rgpPosSettings[id]))) {
          return;
        }
        this.rgpPosSettings[id] = parseFloat(this.rgpPosSettings[id]);
      }
      this.$emit("save", this.rgpPosSettings);
      this.showDialog = false;
    },
    cancel: function () {
      this.$emit("close");
      this.showDialog = false;
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-button {
  width: 45%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: @header-fs+30px;
  }
  border: 1px solid gray;
  height: 50px;
  margin-left: 10px;
}
.el-input /deep/ .el-input__inner {
  font-size: 25px;
}
.inputArea {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-input-group__append,
.el-input-group__prepend {
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/topography/pages/dialog-forms/RgpPos.vue